import { render, staticRenderFns } from "./PatientLabel.vue?vue&type=template&id=33139aec&scoped=true&"
import script from "./PatientLabel.vue?vue&type=script&lang=js&"
export * from "./PatientLabel.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=33139aec&scoped=true&lang=css&"
import style1 from "./PatientLabel.vue?vue&type=style&index=1&id=33139aec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33139aec",
  null
  
)

export default component.exports